import { type FC } from "react"
import { Box, Stack, Text } from "@chakra-ui/react"
import type { Address } from "wagmi"

export enum DelegationType {
  SELF = "self",
  CUSTOM = "custom",
}

export type DelegateeTypeSelectorProps = {
  setDelegatee?: (delegatee: Address | null) => void
  setDelegateeType: (delegateeType: DelegationType | null) => void
  meAddress: Address
  delegateeType: DelegationType | null
}

const DelegateeTypeSelector: FC<DelegateeTypeSelectorProps> = ({
  setDelegatee,
  setDelegateeType,
  delegateeType,
  meAddress,
}) => {
  const options = [
    {
      label: "Myself",
      description: "You will vote directly on proposals",
      value: DelegationType.SELF,
      onClick: () => {
        setDelegatee && setDelegatee(meAddress)
        setDelegateeType(DelegationType.SELF)
      },
    },
    {
      label: "Someone else",
      description: "Another address will vote on your behalf",
      value: DelegationType.CUSTOM,
      onClick: () => {
        setDelegateeType(DelegationType.CUSTOM)
      },
    },
  ]

  return (
    <Stack spacing={4}>
      {options.map((option) => (
        <Box
          key={option.value}
          borderColor={delegateeType === option.value ? "gray.900" : "gray.200"}
          borderRadius="md"
          borderWidth={1}
          cursor="pointer"
          p={4}
          onClick={option.onClick}
        >
          <Text fontSize="xl" fontWeight="semibold">
            {option.label}
          </Text>
          <Text color="gray.600">{option.description}</Text>
        </Box>
      ))}
    </Stack>
  )
}

export default DelegateeTypeSelector
